export const ProjectActionTypes = {
  SET_WARNING_MESSAGE: 'SET_WARNING_MESSAGE',
  SET_LOADING: 'SET_LOADING',
  SET_CURRENT: 'SET_CURRENT',
  SET_MENU: 'SET_MENU',
  SET_DEFAULT: 'SET_DEFAULT',
  SET_BREADCRUMB_TITLE: 'SET_BREADCRUMB_TITLE',
  PAGE_LOAD: 'PAGE_LOAD',
  SET_LANGUAGE: 'SET_LANGUAGE'
}